import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, orderBy, onSnapshot, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './GrnPage.css';
import ViewGrnModal from './ViewGrnModal'; // Assuming you have this component

const GoodsReceivedNotesPage = () => {
    const [grns, setGrns] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedGrn, setSelectedGrn] = useState(null);

    // --- UPDATED: Using onSnapshot for real-time updates ---
    useEffect(() => {
        setLoading(true);
        const grnsCollectionRef = collection(db, "grocery grns");
        const q = query(grnsCollectionRef, orderBy("createdAt", "desc"));

        // This listener will automatically update the UI when GRNs are added or deleted
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const grnsList = querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            setGrns(grnsList);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching GRNs in real-time: ", error);
            setLoading(false);
            // Optionally set an error state to show in the UI
        });

        // Cleanup the listener when the component unmounts
        return () => unsubscribe();
    }, []); // Empty dependency array ensures this runs only once to set up the listener

    // Helper to format currency
    const formatPrice = (price) => {
        if (typeof price !== 'number') return 'N/A';
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(price);
    };

    // Helper to format Firestore Timestamps into readable dates
    const formatTimestamp = (timestamp) => {
        if (!timestamp || typeof timestamp.toDate !== 'function') {
            return 'N/A';
        }
        return new Date(timestamp.toDate()).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    // Helper to create a sequential display ID
    const formatDisplayId = (index, totalItems) => {
        const sequentialNumber = totalItems - index;
        return `GRN-${String(sequentialNumber).padStart(4, '0')}`;
    };

    // Opens the modal with the details of the selected GRN
    const handleView = (grn, displayId) => {
        setSelectedGrn({ ...grn, displayId });
        setIsModalOpen(true);
    };

    // Deletes a GRN document from Firestore
    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this GRN? This action cannot be undone.")) {
            try {
                await deleteDoc(doc(db, "grocery grns", id));
                alert("GRN deleted successfully.");
                // No need to manually filter state, onSnapshot will update the list automatically
            } catch (error) {
                console.error("Error deleting GRN: ", error);
                alert("Failed to delete GRN.");
            }
        }
    };

    if (loading) {
        return <div className="centered-message">Loading GRNs...</div>;
    }

    return (
        <>
            <div className="list-container-grn">
                <div className="list-header-grn">
                    <h1>Goods Received Notes</h1>
                    {/* --- REMOVED state passing. The AddGrnPage should be self-sufficient. --- */}
                    <Link to="/grns/add" className="add-grn-button">
                        Add New GRN
                    </Link>
                </div>
                <div className="table-wrapper-grn">
                    <table className="grn-table">
                        <thead>
                            <tr>
                                <th>GRN ID</th>
                                <th>Purchase Date</th>
                                <th>Received By</th>
                                <th>Total Price</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {grns.length === 0 ? (
                                <tr><td colSpan="5" style={{ textAlign: 'center' }}>No GRNs found.</td></tr>
                            ) : (
                                grns.map((grn, index) => {
                                    const displayId = formatDisplayId(index, grns.length);
                                    return (
                                        <tr key={grn.id}>
                                            <td className="grn-id-cell">{displayId}</td>
                                            {/* --- FIX: Formatting the purchaseDate timestamp --- */}
                                            <td>{formatTimestamp(grn.purchaseDate)}</td>
                                            {/* --- FIX: Using the correct field 'receivedBy' --- */}
                                            <td>{grn.receivedBy}</td>
                                            <td>{formatPrice(grn.totalPurchasePrice)}</td>
                                            <td className="actions-cell">
                                                <button onClick={() => handleView(grn, displayId)} className="action-button view">View</button>
                                                <button onClick={() => handleDelete(grn.id)} className="action-button delete">Delete</button>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {isModalOpen && selectedGrn && (
                <ViewGrnModal
                    grn={selectedGrn}
                    onClose={() => setIsModalOpen(false)}
                />
            )}
        </>
    );
};

export default GoodsReceivedNotesPage;